module.exports = __webpack_public_path__ + "media/application/images/home/intro_images/feature_height_mob-ab57a6bed5bc9106afc92e98ba26343c.jpg";